import React from 'react';
import Navbar from '..';

const TopNavbar: React.FC = (): JSX.Element => {
    return <Navbar />;
};

export default TopNavbar;
